module.exports = __webpack_public_path__ + "static/img/oddnary-variation-6.a93c34ba.jpg";